import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import {
  advancedBooleanOperators,
  advancedOperators,
  standardOperators,
  advancedEnumOperators
} from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { ProductMap, ProductFamily } from '../../../../store/ProductMap';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers';
import { ComponentName, getMetaData } from '../../../Compounds/DetailsDrawer/detailsDrawersHelpers';

export const DefaultProductMapGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.PRODUCT_MAP, id: params.row.id }),
          replace: true
        }}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    headerName: 'Salesforce Product',
    field: 'productName',
    flex: 3,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<ProductMap>) => (
      <a
        className="text-indigo"
        title="Open in Salesforce"
        href={`${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${params.row.productSfId}/view`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.productName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'RPM Product',
    field: 'rpmProductName',
    flex: 3,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<ProductMap>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Product.aspx?Item=${params.row.rpmProductId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.rpmProductName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    headerName: 'RPM Supplier',
    field: 'rpmProductSupplierName',
    flex: 2,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<ProductMap>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Supplier.aspx?Item=${params.row.rpmProductSupplierId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.rpmProductSupplierName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'note',
    headerName: 'Note',
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    flex: 1,
    sortable: true,
    filterable: true,
    filterOperators: standardOperators(),
    description: 'Drag to move column',
    renderCell: (params: GridCellParams<ProductMap>) => <div className="text-small">{params.row.note || 'None'}</div>
  },
  {
    field: 'productSfId',
    headerName: 'Salesforce ID',
    sortable: true,
    filterable: true,
    flex: 2,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'productFamily',
    headerName: 'Product Family',
    sortable: true,
    filterable: true,
    flex: 2,
    type: 'singleSelect',
    valueOptions: Object.values(ProductFamily ?? {}),
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedEnumOperators(true),
    description: 'Drag to move column'
  },
  {
    field: 'rpmProductId',
    headerName: 'RPM ID',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'reviewRequired',
    headerName: 'Review Required',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedBooleanOperators(),
    description: 'Drag to move column',
    renderCell: (params: GridCellParams) => (params.value ? 'Yes' : 'No')
  }
];
